<template>
  <div class="wrapper">
    <div class="tilte-text"> 我的好友 </div>
    <div class="search-wrap" style="margin-top: 20px;">
      <template>
        <span class="search-label">会员昵称</span>
        <Input v-model="searchForm.nickName" placeholder="会员昵称" style="width: 150px;" />
      </template>
      <!--<template>-->
        <!--<Input v-model="searchForm.phone" placeholder="手机号" style="width: 150px;" />-->
      <!--</template>-->
<!--      <template>-->
<!--        <span class="search-label">推荐人ID</span>-->
<!--        <Input v-model="searchForm.parentSourceId" placeholder="推荐人ID" style="width: 150px;" />-->
<!--      </template>-->
      <br>
      <template>
        <span class="search-label">下单次数</span>
        <Input v-model="searchForm.orderCountMix" placeholder="下单次数" style="width: 150px;" />
        <span class="search-rang-label">至</span>
        <Input v-model="searchForm.orderCountMax" placeholder="下单次数" style="width: 150px;" />
      </template>
      <template>
        <span class="search-label">注册日期</span>
        <DatePicker type="date" placeholder="开始时间" v-model="searchForm.createStartTime" style="width: 150px;"></DatePicker>
        <span class="search-rang-label">至</span>
        <DatePicker type="date" placeholder="结束时间" v-model="searchForm.createEndTime"></DatePicker>
      </template>
      <template>
        <Button type="text" class="search-btn margin-left-30" @click="handleFilter">查询</Button>
      </template>
    </div>
    <div class="table-wrapper">
      <Table border
             :columns="columns"
             :data="list"
             :loading="listLoading"
             >
        <template slot-scope="{ row }" slot="action">
          <div class="div-flex">
            <span class="color-ff4" style="cursor: pointer" @click="toOrder(row)">查看订单</span>
          </div>
        </template>
      </Table>
      <div style="padding: 10px 0px">
        <Page :total="total"
              :current="searchForm.page"
              show-sizer
              show-elevator
              show-total
              @on-change="changePage"
              @on-page-size-change="changePagesize"
              ></Page>
      </div>
    </div>
    <SetDirector ref="SetDirector" @refresh="getList(true)"></SetDirector>
    <CancelDirector ref="CancelDirector" @refresh="getList(true)"></CancelDirector>
    <CreateQrcode ref="CreateQrcode"></CreateQrcode>
    <Detail ref="Detail"></Detail>
  </div>
</template>
<script>
  import { getPlatformUuidKfc } from '@/utils/auth'
  import { Icon, Table, Page, Button, Select, Option, Input, DatePicker, RadioGroup, Radio } from 'view-design'
  import { getDate, numFormatter } from '@/utils/date'
  import SetDirector from '@/views/pc/kfc/member/modal/SetDirector'
  import CancelDirector from '@/views/pc/kfc/member/modal/CancelDirector'
  import CreateQrcode from '@/views/pc/kfc/member/modal/CreateQrcode'
  import Detail from '@/views/pc/kfc/member/modal/Detail'
  import member from '@/javaApi/kfc/member'
  const memberModel = new member()
  export default {
    name: 'Member',
    components: {
      Icon,
      Table,
      Page,
      Button,
      Select,
      Option,
      Input,
      DatePicker,
      RadioGroup,
      Radio,
      SetDirector,
      CancelDirector,
      CreateQrcode,
      Detail
    },
    data: function () {
      return {
        columns: [
          {
            title: '序号',
            key: 'sequence'
          },
          {
            title: '微信名',
            key: 'nickName',
            ellipsis: true,
            render: (h, params) => {
              let nickname= params.row.nickName
              let avatar = params.row.headPic
              let renderData = []
              if(avatar) {
                renderData.push(
                  h('img',{
                      attrs:{
                        src: avatar,
                        style: 'width: 24px;border-radius: 12px; margin-right: 10px;'
                      },
                  })
                )
              }
              renderData.push(
                h('span', {}, nickname)
              )
              return renderData
            }
          },
          // {
          //   title: '手机号',
          //   key: 'phone'
          // },
          // {
          //   title: '推荐人ID',
          //   key: 'parentSourceId'
          // },
          {
            title: '下单次数',
             key: 'orderCount'
          },
          {
            title: '注册时间',
            key: 'createTime',
          },
          {
            title: '最后下单时间',
            key: 'lastOrderTime',
            // width: 150,
          },
          {
            title: '操作',
            slot: 'action',
            align: 'center',
            // width: 260,
          }
        ],
        listLoading: false,
        list:[
        ],
        total:0,
        searchForm: {
          page: 1,
          pagesize: 10,
          nickName: undefined,
          id:undefined,
          start_num:undefined,
          end_num:undefined,
          createStartTime: undefined,
          createEndTime: undefined,
          orderCountMix: undefined,
          orderCountMax: undefined,
          sort: '-id'
        },
        platformUuid: getPlatformUuidKfc()
      }
    },
    created() {
      this.getList(true)
    },
    computed:{
    },
    methods: {
      getList(first = false){
        if(first === true){
          this.searchForm.page = 1
        }
        let userParam = {
          pageNo:this.searchForm.page,
          pageSize:this.searchForm.pagesize,
          id: numFormatter(this.searchForm.id),
          nickName:this.searchForm.nickName,
          createStartTime:getDate(this.searchForm.createStartTime),
          createEndTime: getDate(this.searchForm.createEndTime),
          orderCountMix:numFormatter(this.searchForm.orderCountMix),
          orderCountMax: numFormatter(this.searchForm.orderCountMax),
        }
        this.listLoading = true
        let that = this
        let condition = (this.platformUuid == '' || this.pstatisticslatformUuid == 0);
        if(!condition){
          userParam.platformUuid = this.platformUuid
        }
        if(userParam.createStartTime){
          userParam.createStartTime = userParam.createStartTime+' 00:00:00'
        }else{
          delete userParam.createStartTime
        }
        if(userParam.createEndTime){
          userParam.createEndTime = userParam.createEndTime+' 23:59:59'
        }else{
          delete userParam.createEndTime
        }
        userParam = this.formateInit(userParam)
        memberModel.getUserList(userParam).then(response=>{
          console.log(response)
          let res = response.data
          if(res.code === 200){
            that.listLoading = false
            that.list = res.data?res.data.list:[]
            that.list = that.formateData(that.list)
            that.total = res.data.total
            that.searchForm.pagesize = res.data.pageSize
          }else{
            that.listLoading = false
            let message = res.message?res.message:'系统繁忙请稍后再试！'
            this.$message.error(message)
          }
        }).catch(error=>{
          that.listLoading = false
            if(error != 'token invalid'){
                this.$message.error('系统繁忙请稍后再试!')
            }

        })

      },
      formateData(data){
        if(!data){
          return []
        }
        if(!data.length){
          return []
        }
        let i = 0;
        let pageNo = this.searchForm.page
        let pageSize = this.searchForm.pagesize
        for(i=0;i<data.length;i++){
          data[i].sequence = (i+1)+(pageNo - 1)*pageSize
        }
        return  data
      },
      formateInit(formData){
        let objCopy = {};
        for(let key in formData){
          if(formData[key]){
            objCopy[key] = formData[key];
          }
        }
        return objCopy;
      },
      handleFilter(){
        this.getList(true)
      },
      changePage(value){
        this.searchForm.page = value
        this.getList()
      },
      changePagesize(value){
        this.searchForm.pagesize = value;
        //如果处于第一页改变数量，则会触发changePage
        if(this.searchForm.page == 1){
          this.getList()
        }
      },
      //查看订单
      toOrder(row){
		    this.$store.dispatch('nav/changeKfcAccountActiveIndex',3)
        this.$router.push({ path: '/pc/kfc/order', query: { user_id:row.id }})
      },
      //设为总监
      setDirector(row){
        let param = {
          uuid: row.uuid
        }
        memberModel.userQueryJunior(param).then(response=>{
          let res = response.data
          if(res.code == 200){
              // 1 ：用户无推荐人 2：用户有推荐人但无下级 3：用户有推荐人且有下级
            if(res.data == 3){
              row.isHasNextLevel = 1
            }
            this.$refs.SetDirector.init(true,row)
          }else{
            let message = res.message?res.message:'系统繁忙请稍后再试！'
            this.$message.error(message)
          }
        }).catch(error=>{
            this.$message.error('系统繁忙请稍后再试')
        })
      },
      //取消总监
      cancelDirector(row){
        this.$refs.CancelDirector.init(true,row)
      },
      //查看详细资料
      showDetail(row){
        this.$refs.Detail.init(true,row)
      },
      //生成二维码
      createQrcode(row){
        this.$refs.CreateQrcode.init(true,row)
      }
    }
  }
</script>
<style scoped>
  .wrapper {
    width: 100%;
    font-size: 12px;
  }
  .wrapper .tilte-text {
    font-size: 18px;
    color: #222222;
    text-align: left;
    font-weight: bold;
  }
  .wrapper .table-wrapper {
    margin-top: 30px;
  }
  .search-wrap .ivu-icon-ios-arrow-down:before{
    color: #232323;
    content: "\F33D";
  }
  .ivu-date-picker-rel {
    margin: 11px 0;
  }
  .ivu-table{
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    border-radius: 2px;
  }
  .table-wrapper .ivu-table-header th {
    background-color: #FCFAF8 !important;
  }
  .table-wrapper .ivu-table-header th .ivu-table-cell{
    color: #222222 !important;
  }
  .table-wrapper .ivu-table-wrapper-with-border{
    border: none;
  }
  .table-wrapper .ivu-table-wrapper-with-border{
    border-radius: 0px;
    border-color: #FFFFFF !important;
  }
  .div-flex{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .div-flex .color-ff4{
    /*width: 50%;*/
    color: #D63036;
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/kfc/member/Index.vue